export const addToCart = ({ id, quantity, properties = {}, sellingPlan = false, cartOpen = true, buttonElement=null }) => {
  const item = { id, quantity, properties }
  if (sellingPlan) {
    item.selling_plan = sellingPlan
  }

  if (buttonElement) buttonElement.classList.add('loading')
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [item]
    })
  })
    .then((blob) => blob.json())
    .then((response) => {
      if (buttonElement) buttonElement.classList.remove('loading')
      if (cartOpen) document.querySelector('cart-notification').getCart()
    })
}

export const addItemsToCart = (items = [], cartOpen = true, buttonElement=null, callback=null) => {
  if (buttonElement) buttonElement.classList.add('loading')
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: items
    })
  })
    .then((blob) => blob.json())
    .then((response) => {
      if (cartOpen) document.querySelector('cart-notification').getCart()
      if(callback) callback(response)
    })
    .finally(() => {
      if(buttonElement) buttonElement.disabled = false
      buttonElement?.classList?.remove('loading')
    })
}